export default __webpack_public_path__ + "assets/icons/pickedup.380f2db4.svg";